import { render, staticRenderFns } from "./SideTabs.vue?vue&type=template&id=155032cd&scoped=true&"
import script from "./SideTabs.vue?vue&type=script&lang=ts&"
export * from "./SideTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SideTabs.vue?vue&type=style&index=0&id=155032cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155032cd",
  null
  
)

export default component.exports